import { Component } from '@angular/core';

@Component({
  selector: 'app-evidence-sign-sidebar',
  templateUrl: './evidence-sign-sidebar.component.html',
  styleUrls: ['./evidence-sign-sidebar.component.scss']
})
export class EvidenceSignSidebarComponent {

}
